import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const COLORS = ['#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe', '#00f2fe'];

const Visualizations = ({ data }) => {
  if (!data || !data.visualization) {
    return null;
  }

  const { type, chartData, title, description } = data.visualization;

  const renderChart = () => {
    switch (type) {
      case 'bar':
        return (
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.2)" />
              <XAxis dataKey="name" stroke="white" fontSize={12} />
              <YAxis stroke="white" fontSize={12} />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white'
                }}
              />
              <Bar dataKey="value" fill="#667eea" radius={4} />
            </BarChart>
          </ResponsiveContainer>
        );

      case 'pie':
        return (
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                outerRadius={60}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white'
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        );

      case 'metrics':
        return (
          <div className="va-metrics-grid">
            {chartData.map((metric, index) => (
              <div key={index} className="va-metric-card">
                <div className="va-metric-value">{metric.value}</div>
                <div className="va-metric-label">{metric.label}</div>
                <div className="va-metric-unit">{metric.unit}</div>
              </div>
            ))}
          </div>
        );

      default:
        return (
          <div className="va-viz-placeholder">
            <p>Visualization type "{type}" not supported</p>
          </div>
        );
    }
  };

  return (
    <div className="va-visualizations">
      <h4>{title}</h4>
      {description && <p className="va-viz-description">{description}</p>}
      {renderChart()}
    </div>
  );
};

export default Visualizations;
